export const LIST = 'AVAILABLE_WIDGETS.LIST';


// WEBPACK FOOTER //
// ./src/constants/AvailableWidget.ts